import React, { PropsWithChildren } from 'react'
import { makeStyles } from '@material-ui/core'
import { Button, Icon, Typography } from 'foundations-library/components'
import EmphasizedSection from './EmphasizedSection'

const jss = (theme) => {
    return {
        infoSection: {
            display: 'flex',
            gap: 10,
            '& ul': {
                marginBottom: 0,
                paddingLeft: 15,
                '& li': {
                    listStyleType: 'disc'
                }
            }
        },
        icon: {
            flexShrink: 0
        }
    }
}

const useStyles = makeStyles(jss)

interface PropsInterface {
    link?: string,
    linkText?: string,
    className?: string,
    'data-testid'?: string
}

/**
 *
 */
const InfoSection = ({
    children,
    link,
    linkText = 'Learn more',
    className,
    'data-testid': dataTestId = 'info-section'
}: PropsWithChildren<PropsInterface>): JSX.Element => {
    const styles = useStyles()

    const onClick = () => {
        if (link) {
            window.open(link, '_blank', 'noopener,noreferrer')
        }
    }

    return <EmphasizedSection className={`${styles.infoSection} ${className}`} data-testid={dataTestId}>
        <Icon name='infotip-stylized' color='neutral-900' className={styles.icon} data-testid={`${dataTestId}-icon`} />
        <div>
            <Typography variant='body3' color='neutral-700' data-testid={`${dataTestId}-text`}>
                {children}
            </Typography>
            {link ? <Button variant='text' color='primary' onClick={onClick} data-testid={`${dataTestId}-button`}>{linkText}</Button> : null}
        </div>
    </EmphasizedSection>
}

export default InfoSection
